import { apiRoutes } from '../../api-routes';
import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '../../util/http-client';
import type { OrderTracking } from './type';
import { orderTrackingFromJSON } from './utils';

export const getOrderTrackingViaTrackingNumberFn = async (
  trackingNumber: string,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<OrderTracking>(
    apiRoutes.tracking.viaTrackingNumber(trackingNumber),
    {
      ...config,
    }
  );

  return orderTrackingFromJSON(response.data);
};
